import frustumCull from '../frustumCull'

export const securityShieldVertexShader = `
  varying vec2 vUv;
  void main(){
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`

export const securityShieldFragmentShader = `
  varying vec2 vUv;
  uniform sampler2D uTexture;
  uniform vec4 uRectData;
  uniform vec4 uProgress;

  void main(){
    vec4 color = texture2D(uTexture, vUv);
    ${frustumCull}

    color.rgb /= color.a;
    gl_FragColor = color;
    gl_FragColor.a *= uProgress.x;
  }
`
